<template lang="pug">
md-input-container(:class='{ "md-input-invalid" : showRequiredError }')
  label(for='genre') Genres
  md-select#genre(name='genre', :multiple='multiple', v-model='selected', @selected='onGenreSelected')
    md-option(v-for='genre in genres', :value='genre' :key="genre") {{ genre | uppercase() }}
  span.md-error(v-if='showRequiredError') This field is required
</template>

<script>
  import genreService from '../../services/genreService';

  export default {
    props: {
      value: {
        type: [String, Array],
        required: true
      },
      multiple: {
        type: Boolean,
        default: false
      },
      showRequiredError: {
        type: Boolean,
        default: false
      }
    },
    data() {
      return {
        selected: this.value,
        genres: [...genreService.getSupportedGenres()]
      };
    },
    methods: {
      onGenreSelected(value) {
        this.$emit('input', value);
      }
    },
    watch: {
      value(newValue) {
        if (newValue) {
          this.selected = newValue;
        }
      }
    },
    filters: {
      uppercase: function(value) {
        if (!value) {
          return '';
        }
        value = value.toString();
        return value.charAt(0).toUpperCase() + value.slice(1);
      }
    }
  };
</script>



// WEBPACK FOOTER //
// src/shared-components/genre/GenresFormSelector.vue